import { render } from "./DeleteChannelDialog.vue?vue&type=template&id=324c3d84"
import script from "./DeleteChannelDialog.vue?vue&type=script&lang=js"
export * from "./DeleteChannelDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__